/* eslint-disable max-params */
/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

export const buildEndpoint = (input, options, isSapUp, cloudConfig, entitlements) => {

    let endpoint;

    const sapPing = 'sap-status';

    endpoint = null;

    const isCloudPrefferred = options && entitlements && entitlements.some(service => {

        if (service.key === options.endpointId && service.value === 'true') {

            return true;

        }
        return false;

    });

    if (options && options.endpointId === sapPing) {

        endpoint = input;

    } else if (isCloudPrefferred) {

        endpoint = cloudConfig.baseUrl + input;

    } else if (options && options.cloudPreferred || options && (!isSapUp && cloudConfig.availableCloudServices.includes(options.endpointId))) {

        endpoint = cloudConfig.baseUrl + input;

    } else if (isSapUp) {

        endpoint = input;

    }

    return endpoint;

};



// WEBPACK FOOTER //
// ./src/shared/services/end-point.js